import { createContext, useEffect, useContext, useState } from 'react';
import { api } from '../../../services/api';
import { toast } from 'react-toastify';
import { useMisc } from '../../../contexts/MiscContext';
import PAChecklistFollowUp from './pa_checklist_followup_main';
import { isNullish } from '../../../utils/misc_utils';
import CookiesService from '../../../services/cookies';
import styles from './pa_checklist_followup.module.scss'
// import io from 'socket.io-client';
// const socket_url = process.env.REACT_APP_BASE_SOCKET_URL;

const PAChecklistFollowUpContext = createContext();
export const usePAChecklistFollowUp = () => useContext(PAChecklistFollowUpContext);

export const PAChecklistFollowUpProvider = () => {
  const { setShowLoading } = useMisc();
  const [socket, setSocket] = useState(null);

  const [isAdmin] = useState(CookiesService.isUserAdmin());
  const [usuarioAdminFup] = useState(CookiesService.getAcessos()['PA - Checklist - Admin-FUP']);
  const [usuarioGestaoFup] = useState(CookiesService.getAcessos()['PA - Checklist - Gestão']);

  const [listaStatus, setListaStatus] = useState([]);
  const [listaDestino, setListaDestino] = useState([]);
  const [listaDestino2Q, setListaDestino2Q] = useState([]);
  const [listaPendenciaUm, setListaPendenciaUm] = useState([]);
  const [listaPendenciaDois, setListaPendenciaDois] = useState([]);
  const [listaStatusCadeia, setListaStatusCadeia] = useState([]);
  const [listaCanal] = useState([
    { label: 'ATACADO', value: '%ATACADO%' },
    { label: 'VAREJO', value: '%VAREJO%' },
    { label: 'FRANQUIA', value: '%FRANQUIA%' }
  ]);
  const [mainGridData, setMainGridData] = useState([]);
  const [mainGridDataPrio, setMainGridDataPrio] = useState([]);
  const [itemSelecionado, setItemSelecionado] = useState({});
  const [modalFup, setModalFup] = useState(false);
  const [tab, setTab] = useState(0);
  const [listaOrigem, setListaOrigem] = useState([]);
  const [listaColecao, setListaColecao] = useState([]);
  const [listaMarca, setListaMarca] = useState([]);
  const [listaTipoProduto, setListaTipoProduto] = useState([]);
  const [listaDestinoInternacional, setListaDestinoInternacional] = useState([]);
  const [listaDestinoNacional, setListaDestinoNacional] = useState([]);
  const [listaStatusFinal, setListaStatusFinal] = useState([]);
  const [formularioFinalizacao, setFormularioFinalizacao] = useState({
    pendente: false,
    status_final: null,
    atribuicao_pendenciado: null,
    atribuicao_estilo: null,
    observacoes_analista: '',
    orientacoes_conserto: '',
    responsavel_estilo: null,
    novo_direcionamento: null,
    indica_culpabilidade: false
  });
  const [filterForm, setFilterForm] = useState({
    colecao: [],
    marca: [],
    canal: [],
    tipo_produto: [],
    origem: [],
    status_cadeia: [],
    localizacao: null,
    multi: '',
    priorizado: null,
    finalizado: null,
    data_recebimento_inicio: '',
    data_recebimento_fim: '',
    status_final: []
  });
  const [oldFilters, setOldFilters] = useState({ ...filterForm });
  const [modalDivergenciaFinal, setModalDivergenciaFinal] = useState(false);
  const [dadosResultadoFinal, setDadosResultadoFinal] = useState({
    qtdeTotalProd: 0,
    limitePecasDefeituosas: 0,
    segundaQualidade: false,
    produtoDeCouro: false,
    pecasDefeituosasRev: 0,
    pecasDefeituosasAnalise: 0,
    pecasDevolvidasRev: 0,
    pecasDevolvidasAnalise: 0,
    totalPecasDefeituosas: 0,
    totalPecasDevolvidas: 0,
    statusSugerido: '',
    possuiDirecionamento2Q: false,
    resCaixa: [],
    resRevisao: []
  });
  const [showModalHistoricoReanalise, setShowModalHistoricoReanalise] = useState(false);
  const [historicoReanalise, setHistoricoReanalise] = useState([]);
  const [showResumo, setShowResumo] = useState(false);
  const [showDispensa, setShowDispensa] = useState(false);
  const [listaProdutosDispensa, setListaProdutosDispensa] = useState([]);

  // const socketConnect = async () => {
  //   const newSocket = io(`${socket_url}`, {
  //     transports: ['websocket'],
  //     query: { interfaceType: 'checklist' }
  //   });
  //   setSocket(newSocket);

  //   return {
  //     socket: newSocket,
  //     cleanup: () => {
  //       if (newSocket) {
  //         newSocket.close();
  //       }
  //     }
  //   }
  // }

  // useEffect(() => {
  //   (async () => await socketConnect())();
  // }, []);

  const resetForm = () => {
    setFormularioFinalizacao({
      pendente: false,
      status_final: null,
      atribuicao_pendenciado: null,
      atribuicao_estilo: null,
      observacoes_analista: '',
      orientacoes_conserto: '',
      responsavel_estilo: null,
      novo_direcionamento: null,
      indica_culpabilidade: false
    });
  }

  const limparFiltros = () => {
    setFilterForm({
      colecao: [],
      marca: [],
      canal: [],
      tipo_produto: [],
      origem: [],
      status_cadeia: [],
      localizacao: null,
      multi: '',
      priorizado: null,
      finalizado: null,
      data_recebimento_inicio: '',
      data_recebimento_fim: ''
    });
  }

  function simplificarFiltros(filtro) {
    const filtroSimplificado = {};

    for (const [chave, valor] of Object.entries(filtro)) {
      if (Array.isArray(valor)) {
        filtroSimplificado[chave] = valor.map(v =>
          v && typeof v === 'object' && 'value' in v ? v.value : v
        );
      } else if (valor && typeof valor === 'object' && 'value' in valor) {
        filtroSimplificado[chave] = valor.value;
      } else {
        filtroSimplificado[chave] = valor;
      }
    }

    return filtroSimplificado;
  }

  useEffect(() => {
    (async () => {
      try {
        setShowLoading(true);
        const resIni = await api.get('pa/checklist-fup/checklist-fup-inicializacao');
        setListaStatus(resIni.data.resListaStatus);
        setListaDestino(resIni.data.resDestinoList);
        setListaDestino2Q(resIni.data.resDestinoList2Q);
        setListaPendenciaUm(resIni.data.resListaPendenciaUm);
        setListaPendenciaDois(resIni.data.resListaPendenciaDois);
        setListaStatusCadeia(resIni.data.resListaStatusCadeia);
        setListaOrigem(resIni.data.resListaOrigem);
        // setListaCanal(resIni.data.resListaCanal);
        setListaColecao(resIni.data.resListaColecao);
        setListaMarca(resIni.data.resListaMarca);
        setListaTipoProduto(resIni.data.resListaTipoProduto);
        setListaDestinoInternacional(resIni.data.resListaDestinoInternacional);
        setListaDestinoNacional(resIni.data.resListaDestinoNacional);
        setListaStatusFinal(resIni.data.resListaStatusFinal);

        const res = await api.post('pa/checklist-fup/checklist-fup-main-grid', simplificarFiltros(filterForm));
        setMainGridData([...res.data]);
        setMainGridDataPrio([...res.data].filter(i => (!i.finalizacao_ok && !i.checklist_ok)));
      } catch (e) {
        toast.error('Erro ao inicializar a interface, por favor recarregue a página ou entre em contato com o suporte.');
      } finally {
        setShowLoading(false);
      }
    })();
  }, []);

  const getFilteredGrid = async () => {
    try {
      setShowLoading(true);

      const res = await api.post('pa/checklist-fup/checklist-fup-main-grid', simplificarFiltros(filterForm));
      setMainGridData([...res.data]);
      setMainGridDataPrio([...res.data].filter(i => (!i.finalizacao_ok && !i.checklist_ok)));
      setOldFilters({ ...filterForm });
    } catch (e) {
      toast.error('Ocorreu um erro durante o carregamento do grid. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const reducer = (arr) => {
    return arr.reduce((acc, dir) => {
      if (dir.id_destino !== 1 && dir.id_destino !== 40) acc.pecasDefeituosas += dir.qtde_pecas;
      if (dir.id_destino === 4 || dir.id_destino === 43 || dir.id_destino === 41) acc.pecasDevolvidas += dir.qtde_pecas;
      if (listaDestino2Q.some(destino => destino.value === dir.id_destino)) acc.possuiDirecionamento2Q = true;
      return acc;
    }, { pecasDefeituosas: 0, pecasDevolvidas: 0, possuiDirecionamento2Q: false });
  }

  const calcLimitePecas = (qtdeProd, nfSegundaQualidade, produtoDeCouro) => {
    if (nfSegundaQualidade || produtoDeCouro) return qtdeProd;
    if (qtdeProd === 1) return 1
    if (qtdeProd >= 2 && qtdeProd < 15) return 1;
    if (qtdeProd >= 16 && qtdeProd < 50) return 2;
    if (qtdeProd >= 51 && qtdeProd < 150) return 2;
    if (qtdeProd >= 151 && qtdeProd < 280) return 3;
    if (qtdeProd >= 281 && qtdeProd < 500) return 4;
    if (qtdeProd >= 501 && qtdeProd < 1200) return 6;
    if (qtdeProd >= 1201 && qtdeProd < 3200) return 8;
    if (qtdeProd >= 3201 && qtdeProd < 10000) return 11;
    if (qtdeProd >= 10001 && qtdeProd < 35000) return 15;
    if (qtdeProd >= 35001) return 22;
    // if (qtdeProd > 35001 && qtdeProd < 500000) return 22;
  }

  const calcStatusSugerido = (limite, totalDef, totalDev, resCaixa, resRevisao, possui2QRev, possui2QCheck) => {
    if (resCaixa && (resCaixa.preco_tag_divergente || resCaixa.composicao_tag_divergente)) {
      if (possui2QRev || possui2QCheck) return 7; // Devolução Parcial;
      return 6; // Devolução Total;
    }
    if (resRevisao && (resRevisao.preco_tag_divergente || resRevisao.composicao_tag_divergente)) {
      if (possui2QRev || possui2QCheck) return 7; // Devolução Parcial;
      return 6; // Devolução Total;
    }
    if (totalDef > limite && (possui2QRev || possui2QCheck)) return 7; // Devolução Parcial;
    if (totalDef > limite && !(possui2QRev || possui2QCheck)) return 6; // Devolução Total;
    if (totalDev > 0) return 7; // Devolução Parcial;
    if (totalDef > 0) return 5; // Aprovado com Restrições;
    return 4; // Aprovado;
  }

  const aplicarStatusProvaRoupa = (statusChecklist, statusProvaRoupa) => {
    if (statusChecklist === 6) return 6; // Devolução Total sempre permanece

    const matriz = {
      4: { 4: 4, 5: 5, 8: 6 },
      5: { 4: 5, 5: 5, 8: 6 },
      7: { 4: 7, 5: 7, 8: 6 },
    }

    return matriz[statusChecklist]?.[statusProvaRoupa] ?? statusChecklist;
  }

  const calcDadosResultadoFinal = (revDir, anaDir, qtdeTotalProd, nfSegundaQualidade, produtoDeCouro, statusProvaRoupa, resCaixa, resRevisao) => {
    const {
      pecasDefeituosas: pecasDefeituosasRev,
      pecasDevolvidas: pecasDevolvidasRev,
      possuiDirecionamento2Q: possui2QRev
    } = reducer(revDir);
    const {
      pecasDefeituosas: pecasDefeituosasAnalise,
      pecasDevolvidas: pecasDevolvidasAnalise,
      possuiDirecionamento2Q: possui2QCheck
    } = reducer(anaDir);

    const totalPecasDefeituosas = pecasDefeituosasRev + pecasDefeituosasAnalise;
    const totalPecasDevolvidas = pecasDevolvidasRev + pecasDevolvidasAnalise;

    const limitePecasDefeituosas = calcLimitePecas(qtdeTotalProd, nfSegundaQualidade, produtoDeCouro);
    const statusChecklist = calcStatusSugerido(
      limitePecasDefeituosas,
      totalPecasDefeituosas,
      totalPecasDevolvidas,
      resCaixa,
      resRevisao,
      possui2QRev,
      possui2QCheck
    );
    const statusSugerido = aplicarStatusProvaRoupa(statusChecklist, statusProvaRoupa);

    setDadosResultadoFinal({
      qtdeTotalProd,
      limitePecasDefeituosas,
      nfSegundaQualidade,
      produtoDeCouro,
      pecasDefeituosasRev,
      pecasDefeituosasAnalise,
      pecasDevolvidasRev,
      pecasDevolvidasAnalise,
      totalPecasDefeituosas,
      totalPecasDevolvidas,
      statusChecklist,
      statusProvaRoupa,
      statusSugerido,
      possuiDirecionamento2Q: possui2QRev || possui2QCheck,
      resCaixa,
      resRevisao
    });

    return statusSugerido;
  }

  const getFupData = async (data) => {
    try {
      setShowLoading(true);
      const params = {
        nf_entrada: data.nf_entrada,
        serie_nf: data.serie_nf,
        origem: data.origem,
        produto: data.produto,
        cor_produto: data.cor_produto,
        qtde_entrada: data.qtde_entrada,
        filial_revisao: data.filial_revisao,
        id_entrada_fiscal: data.id_entrada_fiscal,
        ordem_producao: data.ordem_producao
      }

      const res = await api.get('pa/checklist-fup/checklist-fup-get-fup-data', { params });
      setItemSelecionado({
        ...data,
        ...res.data.checklistData,
        ...res.data.checklistDataSEOE,
        ...res.data
      });
      setModalFup(true);
      setHistoricoReanalise(res.data.historicoReanalise);

      const statusSugerido = calcDadosResultadoFinal(
        res.data.revisaoDirecionamentos,
        res.data.analiseDirecionamentos,
        data.qtde_entrada,
        res.data.checklistData.nf_segunda_qualidade,
        data.produto_de_couro,
        res.data.resultadoProvaDeRoupa?.id_status || 4,
        res.data.resultadoCaixa,
        res.data.resultadoRevisao
      );

      setFormularioFinalizacao({
        ...formularioFinalizacao,
        status_final: listaStatus.find(obj => obj.value === statusSugerido),
        observacoes_analista: res.data.checklistData.observacao_analista,
        orientacoes_conserto: res.data.checklistData.orientacao_conserto,
        responsavel_estilo: res.data.checklistData.responsavel_analise_pendencia,
        indica_culpabilidade: res.data.analiseDirecionamentos.some(item => item.descricao_destino.includes('%'))
      });
    } catch (e) {
      toast.error('Ocorreu um erro durante o carregamento da referência. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const validarFinalizacaoChecklist = () => {
    const { pendente, status_final, atribuicao_pendenciado, atribuicao_estilo, responsavel_estilo, observacoes_analista, orientacoes_conserto } = formularioFinalizacao;
    const errArr = [];

    if (!pendente && !status_final) errArr.push('Selecione o status final');
    if (pendente && !atribuicao_pendenciado) errArr.push('Selecione a atribuição do pendenciado');
    if (pendente && atribuicao_pendenciado?.value === 1 && !atribuicao_estilo) errArr.push('Selecione a atribuição do estilo');
    if (
      itemSelecionado.pendente && itemSelecionado.id_atribuicao_pendencia === 1
      && (itemSelecionado.id_justificativa_pendencia === 3 || itemSelecionado.id_justificativa_pendencia === 4)
      && (!responsavel_estilo || responsavel_estilo.length < 4)
    ) errArr.push('Responsável pelo estilo inválido(a)');
    // if (isNullish(observacoes_analista)) errArr.push('Observações ');
    if (!pendente && status_final && [6, 7].includes(status_final.value) && isNullish(orientacoes_conserto)) {
      errArr.push('Insira as orientações de conserto');
    }

    return errArr;
  }

  const processarFinalizacaoChecklist = async () => {
    try {
      setShowLoading(true);
      const errArr = validarFinalizacaoChecklist();
      if (errArr.length > 0) {
        return toast.warning(() => {
          return <div>{errArr.map((x, i) => <div key={`err_toast_${i}`}>{x}</div>)}</div>;
        });
      }

      const params = {
        pendente: formularioFinalizacao.pendente,
        status_final: formularioFinalizacao.status_final,
        atribuicao_pendenciado: formularioFinalizacao.atribuicao_pendenciado,
        atribuicao_estilo: formularioFinalizacao.atribuicao_estilo,
        responsavel_estilo: formularioFinalizacao.responsavel_estilo,
        observacoes_analista: formularioFinalizacao.observacoes_analista,
        orientacoes_conserto: formularioFinalizacao.orientacoes_conserto,
        possui_peca_piloto: itemSelecionado.possui_peca_piloto,
        id_usuario_responsavel: CookiesService.getUserId(),
        refData: {
          id_entrada_fiscal: itemSelecionado.id_entrada_fiscal,
          empresa: itemSelecionado.empresa,
          nf_entrada: itemSelecionado.nf_entrada,
          serie_nf: itemSelecionado.serie_nf,
          origem: itemSelecionado.origem,
          produto: itemSelecionado.produto,
          cor_produto: itemSelecionado.cor_produto,
          qtde_entrada: itemSelecionado.qtde_entrada,
          filial_revisao: itemSelecionado.filial_revisao,
          ordem_servico: itemSelecionado.ordem_servico,
          ordem_producao: itemSelecionado.ordem_producao,
          id_tipo_analise: itemSelecionado.nf_segunda_qualidade ? 2 : 1
        },
        status_sugerido: dadosResultadoFinal.statusSugerido,
        indica_culpabilidade: formularioFinalizacao.indica_culpabilidade,
        novo_direcionamento: formularioFinalizacao?.novo_direcionamento?.value || null
      }

      const res = await api.post('pa/checklist-fup/checklist-processamento-finalizacao', params);
      if (res.data.value && res.data.value === 50020) throw 50020;

      await getFupData(itemSelecionado);
      setFormularioFinalizacao({
        pendente: false,
        status_final: null,
        atribuicao_pendenciado: null,
        atribuicao_estilo: null,
        observacoes_analista: res.data.observacao_analista,
        orientacoes_conserto: res.data.orientacao_conserto,
        responsavel_estilo: null,
        novo_direcionamento: null
      });
      toast.success('Processamento completado com sucesso!');
    } catch (e) {
      if (e === 50020) {
        return toast.error('A entrada fiscal já foi finalizada, se isso é um erro recarregue a página ou entre em contato com o suporte.');
      }
      toast.error('Ocorreu um erro durante o processamento da finalização. Por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const fecharModalFup = () => {
    setItemSelecionado({});
    setModalFup(false);
    resetForm();
    setTab(0);
  }

  const infoComp = (label, value) => {
    return (
      <span className={styles.info_label}>
        {label}:&nbsp;
        <span className={styles.info_value}>
          {value}
        </span>
      </span>
    );
  }

  const processarChecklistPriorizacao = async (arrPrioridade, novaPrioridadeBulk = null, novoTipoBulk = null) => {
    try {
      setShowLoading(true);
      const params = {
        arrPrioridade,
        oldFilters: simplificarFiltros(oldFilters),
        id_usuario_responsavel: CookiesService.getUserId()
      }

      if (novaPrioridadeBulk) {
        params.arrPrioridade = arrPrioridade.map(prod => {
          return { ...prod, nova_prioridade: novaPrioridadeBulk.level }
        });
      }

      if (typeof novoTipoBulk === 'boolean') {
        params.arrPrioridade = arrPrioridade.map(prod => {
          return { ...prod, nova_nf_segunda_qualidade: novoTipoBulk }
        });
      }

      params.arrPrioridade = params.arrPrioridade.filter(item =>
        item.prioridade !== item.nova_prioridade || item.nf_segunda_qualidade !== item.nova_nf_segunda_qualidade
      );

      const res = await api.post('pa/checklist-fup/checklist-fup-priorizacao', params);
      setMainGridData([...res.data]);
      setMainGridDataPrio([...res.data].filter(i => (!i.finalizacao_ok && !i.checklist_ok)));
      // await socket.emit('checklist:refresh', 999);
      // await socket.emit('revisao:refresh');

      toast.success('Priorização completada com sucesso!');
    } catch (e) {
      toast.error('Erro ao processar a priorização, por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  const pedirReanalise = async (tipo) => {
    try {
      setShowLoading(true);
      const params = {
        // nf_entrada: itemSelecionado.nf_entrada,
        // serie_nf: itemSelecionado.serie_nf,
        // produto: itemSelecionado.produto,
        // cor_produto: itemSelecionado.cor_produto,
        // filial_revisao: itemSelecionado.filial_revisao,
        // qtde_entrada: itemSelecionado.qtde_entrada,
        // empresa: itemSelecionado.empresa,
        id_entrada_fiscal: itemSelecionado.id_entrada_fiscal,
        id_usuario_responsavel: CookiesService.getUserId(),
        tipo
      }
      const res = await api.post('pa/checklist-fup/checklist-fup-pedir-reanalise', params);
      if (res.data?.ext === 50035) toast.warning('Esta referência já se encontra prendenciada!');

      setHistoricoReanalise([...res.data.logList]);

    } catch (e) {
      toast.error('Erro ao processar a reanálise, por favor tente novamente ou entre em contato com o suporte.');
    } finally {
      setShowLoading(false);
    }
  }

  return (
    <PAChecklistFollowUpContext.Provider
      value={{
        listaStatus, listaDestino, listaPendenciaUm, listaPendenciaDois, mainGridData, mainGridDataPrio, getFupData, itemSelecionado, setItemSelecionado, modalFup, setModalFup, tab, setTab, setListaColecao, formularioFinalizacao, setFormularioFinalizacao, processarFinalizacaoChecklist, infoComp, fecharModalFup, filterForm, setFilterForm, getFilteredGrid, limparFiltros,
        processarChecklistPriorizacao, modalDivergenciaFinal, setModalDivergenciaFinal, dadosResultadoFinal,

        listaStatusCadeia, listaOrigem, listaColecao, listaCanal, listaMarca, listaTipoProduto, listaDestinoInternacional, listaDestinoNacional, listaStatusFinal,

        isAdmin, usuarioAdminFup, usuarioGestaoFup,
        showModalHistoricoReanalise, setShowModalHistoricoReanalise, pedirReanalise, historicoReanalise,
        showResumo, setShowResumo, showDispensa, setShowDispensa, listaProdutosDispensa, setListaProdutosDispensa
      }}
    >
      {< PAChecklistFollowUp />}
    </PAChecklistFollowUpContext.Provider>
  );
}
